import { useMemo } from 'react';
import { SearchableField } from './ISearchableField';

export function useSearchableFields(fields: SearchableField[]) {
  return useMemo(() => {
    return { fields };
  }, [fields]);
}
